import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { setLenis } from "@/lib/scroll";
import Nav, { StickyMobileCta } from "@/components/Nav";
import { LeadModal } from "@/components/LeadModal";
import AdminLeads from "@/pages/AdminLeads";
import Hero from "@/sections/Hero";
import ProofStrip from "@/sections/ProofStrip";
import Problem from "@/sections/Problem";
import BtsMethod from "@/sections/BtsMethod";
import Frameworks from "@/sections/Frameworks";
import Journey from "@/sections/Journey";
import Founder from "@/sections/Founder";
import Ownership from "@/sections/Ownership";
import WhoFor from "@/sections/WhoFor";
import Testimonials from "@/sections/Testimonials";
import Offer from "@/sections/Offer";
import Faq from "@/sections/Faq";
import FinalCta from "@/sections/FinalCta";
import Footer from "@/sections/Footer";

function App() {
  useEffect(() => {
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    if (isTouch) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/leads" element={<AdminLeads />} />
        <Route
          path="*"
          element={
            <div className="bg-white text-[#0A121E] font-sans antialiased selection:bg-[#D4AF37] selection:text-[#08162B]">
              <Nav />
              <main>
                <Hero />
                <Founder />
                <ProofStrip />
                <Problem />
                <BtsMethod />
                <Frameworks />
                <Journey />
                <Ownership />
                <WhoFor />
                <Testimonials />
                <Offer />
                <Faq />
                <FinalCta />
              </main>
              <Footer />
              <StickyMobileCta />
              <LeadModal />
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
